import React, { useCallback, useState, useRef } from 'react'

import PropTypes from 'prop-types'

import isEmpty from 'lodash/isEmpty'
import toLower from 'lodash/toLower'

import { useDialog } from '@galo-monitor/dialog'
import I18n, { useT } from '@galo-monitor/i18n'
import Button from '@galo-monitor/web-components/Button'
import Modal from '@galo-monitor/web-components/Modal'
import RawMaterialForm from '@galo-monitor/web-containers/forms/farm/RawMaterialForm'
import ErrorModal from '@galo-monitor/web-containers/modals/ErrorModal'

const RawMaterialModal = (props) => {
  const {
    id,
    open,
    handleClose,
    onSuccess,
    rawMaterial
  } = props

  const [loading, setLoading] = useState(false)

  const t = useT()
  const { createDialog } = useDialog()

  const formRef = useRef(null)

  const handleConfirm = useCallback(
    () => {
      formRef.current.submit()
    },
    []
  )

  const handleSuccess = useCallback(
    () => {
      handleClose()
      onSuccess()
    },
    [handleClose, onSuccess]
  )

  const onError = useCallback(
    () => {
      setLoading(false)
      createDialog({
        id: 'error-raw-material',
        Component: ErrorModal,
        props: {
          title: `${ t('could not {action} the {this}', {
            howMany: 1,
            gender: 'female',
            action: toLower(t(isEmpty(rawMaterial) ? 'register' : 'update')),
            this: toLower(t('property', { howMany: 1 }))
          })  }.`
        }
      })
    },
    [createDialog, rawMaterial, t]
  )

  return (
    <Modal
      id={ id }
      open={ open }
      loading={ loading }
      title={ t('register of {this}', {
        this: t('raw material', { howMany: 1 })
      }) }
      maxWidth="xs"
      fullWidth
      FooterComponent={ () => (
        <>
          <Button
            id="import"
            onClick={ handleConfirm }
          >
            <I18n>save</I18n>
          </Button>
        </>
      ) }
    >
      <RawMaterialForm
        ref={ formRef }
        rawMaterial={ rawMaterial }
        onSuccess={ handleSuccess }
        onError={ onError }
        loading={ loading }
        setLoading={ setLoading }
      />
    </Modal>
  )
}

RawMaterialModal.propTypes = {
  id: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  rawMaterial: PropTypes.object
}

RawMaterialModal.defaultProps = {
  rawMaterial: {}
}

export default RawMaterialModal
